import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Per-request opt-outs for the dynamic interceptors / SSR cache.
 *
 * These are the real mechanism behind `HttpService`'s fluent
 * `.skipErrorHandler()/.skipApiPrefix()/.skipAcceptLanguage()/.skipCacheInterceptor()`
 * API, but because they live on the request's `HttpContext` the SAME opt-out
 * works for a raw `HttpClient` call or an `httpResource(...)` via `{ context }`.
 */
export const SKIP_API_PREFIX = new HttpContextToken<boolean>(() => false);
export const SKIP_ERROR_HANDLER = new HttpContextToken<boolean>(() => false);
export const SKIP_ACCEPT_LANGUAGE = new HttpContextToken<boolean>(() => false);
export const SKIP_API_CACHE = new HttpContextToken<boolean>(() => false);

/**
 * Returns a fresh `HttpContext` with every token in `skips` set to `true`,
 * carrying over any entries the caller already had on `base`.
 *
 * `base` is copied, never mutated: a caller-supplied `HttpContext` (e.g. from an
 * `httpResource(..., { context })`) can be safely reused across requests without
 * skip tokens leaking onto it.
 */
export function withSkips(skips: ReadonlySet<HttpContextToken<boolean>>, base?: HttpContext): HttpContext {
    const context = new HttpContext();

    if (base) {
        for (const token of base.keys()) {
            context.set(token, base.get(token));
        }
    }

    skips.forEach((token) => context.set(token, true));

    return context;
}
